/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SearchDealsRequestSearchCriteria
 */
export interface SearchDealsRequestSearchCriteria {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'dealStatusList'?: Array<SearchDealsRequestSearchCriteriaDealStatusListEnum>;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'userAccountGroupId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'dealKeyword'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'dealIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'yearMonth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'amountLowerLimit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'amountUpperLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'qualifiedEvidence'?: SearchDealsRequestSearchCriteriaQualifiedEvidenceEnum;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'accountItemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'taxCode'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'itemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'sectionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'tagId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'partnerId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'canSync'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'isInvalidTaxCode'?: boolean | null;
}

export const SearchDealsRequestSearchCriteriaDealStatusListEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type SearchDealsRequestSearchCriteriaDealStatusListEnum = typeof SearchDealsRequestSearchCriteriaDealStatusListEnum[keyof typeof SearchDealsRequestSearchCriteriaDealStatusListEnum];
export const SearchDealsRequestSearchCriteriaQualifiedEvidenceEnum = {
    allNotQualified: 'ALL_NOT_QUALIFIED',
    containQualified: 'CONTAIN_QUALIFIED'
} as const;

export type SearchDealsRequestSearchCriteriaQualifiedEvidenceEnum = typeof SearchDealsRequestSearchCriteriaQualifiedEvidenceEnum[keyof typeof SearchDealsRequestSearchCriteriaQualifiedEvidenceEnum];


